module.exports = __webpack_public_path__ + "static/img/weather_041.eae72f64.svg";